export const possibleColors = ['red','orange','yellow','olive','green','teal','blue','violet','purple','pink','brown','grey'];//,'black'
export function randomColor() {
    return possibleColors[Math.round(Math.random()*(possibleColors.length-1))];
}